function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import { Vector, calculateBounds, getDistances, getRandom, isPointInside, randomInRange } from "tsparticles-engine";
export var OutOutMode = /*#__PURE__*/function () {
  function OutOutMode(container) {
    _classCallCheck(this, OutOutMode);
    this.container = container;
    this.modes = ["out"];
  }
  _createClass(OutOutMode, [{
    key: "update",
    value: function update(particle, direction, delta, outMode) {
      if (!this.modes.includes(outMode)) {
        return;
      }
      var container = this.container;
      switch (particle.outType) {
        case "inside":
          {
            var _particle$velocity = particle.velocity,
              vx = _particle$velocity.x,
              vy = _particle$velocity.y;
            var circVec = Vector.origin;
            circVec.length = particle.moveCenter.radius;
            circVec.angle = particle.velocity.angle + Math.PI;
            circVec.addTo(Vector.create(particle.moveCenter));
            var _getDistances = getDistances(particle.position, circVec),
              dx = _getDistances.dx,
              dy = _getDistances.dy;
            if (vx <= 0 && dx >= 0 || vy <= 0 && dy >= 0 || vx >= 0 && dx <= 0 || vy >= 0 && dy <= 0) {
              return;
            }
            particle.position.x = Math.floor(randomInRange({
              min: 0,
              max: container.canvas.size.width
            }));
            particle.position.y = Math.floor(randomInRange({
              min: 0,
              max: container.canvas.size.height
            }));
            var _getDistances2 = getDistances(particle.position, particle.moveCenter),
              newDx = _getDistances2.dx,
              newDy = _getDistances2.dy;
            particle.direction = Math.atan2(-newDy, -newDx);
            particle.velocity.angle = particle.direction;
            break;
          }
        default:
          {
            if (isPointInside(particle.position, container.canvas.size, Vector.origin, particle.getRadius(), direction)) {
              return;
            }
            switch (particle.outType) {
              case "outside":
                {
                  particle.position.x = Math.floor(randomInRange({
                    min: -particle.moveCenter.radius,
                    max: particle.moveCenter.radius
                  })) + particle.moveCenter.x;
                  particle.position.y = Math.floor(randomInRange({
                    min: -particle.moveCenter.radius,
                    max: particle.moveCenter.radius
                  })) + particle.moveCenter.y;
                  var _getDistances3 = getDistances(particle.position, particle.moveCenter),
                    _dx = _getDistances3.dx,
                    _dy = _getDistances3.dy;
                  if (particle.moveCenter.radius) {
                    particle.direction = Math.atan2(_dy, _dx);
                    particle.velocity.angle = particle.direction;
                  }
                  break;
                }
              case "normal":
                {
                  var wrap = particle.options.move.warp,
                    canvasSize = container.canvas.size,
                    newPos = {
                      bottom: canvasSize.height + particle.getRadius() + particle.offset.y,
                      left: -particle.getRadius() - particle.offset.x,
                      right: canvasSize.width + particle.getRadius() + particle.offset.x,
                      top: -particle.getRadius() - particle.offset.y
                    },
                    sizeValue = particle.getRadius(),
                    nextBounds = calculateBounds(particle.position, sizeValue);
                  if (direction === "right" && nextBounds.left > canvasSize.width + particle.offset.x) {
                    particle.position.x = newPos.left;
                    particle.initialPosition.x = particle.position.x;
                    if (!wrap) {
                      particle.position.y = getRandom() * canvasSize.height;
                      particle.initialPosition.y = particle.position.y;
                    }
                  } else if (direction === "left" && nextBounds.right < -particle.offset.x) {
                    particle.position.x = newPos.right;
                    particle.initialPosition.x = particle.position.x;
                    if (!wrap) {
                      particle.position.y = getRandom() * canvasSize.height;
                      particle.initialPosition.y = particle.position.y;
                    }
                  }
                  if (direction === "bottom" && nextBounds.top > canvasSize.height + particle.offset.y) {
                    if (!wrap) {
                      particle.position.x = getRandom() * canvasSize.width;
                      particle.initialPosition.x = particle.position.x;
                    }
                    particle.position.y = newPos.top;
                    particle.initialPosition.y = particle.position.y;
                  } else if (direction === "top" && nextBounds.bottom < -particle.offset.y) {
                    if (!wrap) {
                      particle.position.x = getRandom() * canvasSize.width;
                      particle.initialPosition.x = particle.position.x;
                    }
                    particle.position.y = newPos.bottom;
                    particle.initialPosition.y = particle.position.y;
                  }
                  break;
                }
            }
            break;
          }
      }
    }
  }]);
  return OutOutMode;
}();